'use client';

import { Icon } from '@/general/Icons/Icon';
import { ControlInputGroup } from '@/general/components/forms/Input/ControlInput/ControlInputGroup';
import { Switch } from '@/general/components/forms/Input/atoms/OptionFieldInput';
import { FilterValues } from '@/types/CataloguePage.types';

import { FilterOption } from '../../PlpFilters.type';

type Props = {
  onChange: (filter: FilterOption) => void;
  value: string;
};

export const AvailableFilterInput = ({ onChange, value }: Props) => {
  return (
    <div className="flex items-center gap-4 px-4 py-3">
      <Icon name="show" />
      <div className="flex-1">
        <ControlInputGroup
          id="state"
          name="state"
          type="switch"
          variant="isolated"
          inputIcon={Switch}
          options={[{ label: 'Show available only', value: 'available' }]}
          inputPlacement="end"
          className="m-0! font-bold"
          value={value}
          onChange={(e) =>
            onChange({ filter: FilterValues.State, value: e, slug: e, label: 'Show available only' } as FilterOption)
          }
        />
      </div>
    </div>
  );
};
